function timeOfDayDirective() {
    return {
        restrict: 'E',
        scope: {
            values: '&',
            field: '&'
        },
        link: function(scope) {
            scope.hour = scope.values()[scope.field().name() + '.hour'];
            var minute = scope.values()[scope.field().name() + '.minute'];
            scope.minute = minute < 10 ? '0' + minute : minute;
        },
        template: '<span>{{ hour }}:{{ minute }}</span>'
    };
}
export default timeOfDayDirective;



// WEBPACK FOOTER //
// ./js/types/maTimeOfDayField.js